export default function SocialMedia() {
  return (
    <div className="dashboard">
      <h1>Social Media Listening</h1>
      <p>
        Measurements of frequency and sentiment of social media activity related
        to contract.
      </p>
      <br />
      <iframe
        src="https://external.sprinklr.com/research/insights/listening/dashboard/65cb97dc817cae59112719be/tab/0?id=21D100A3FD04860C9F58E25A95E70793E708AEA8C9F195662BD873C23F50264D"
        title="Social Media Listening Dashboard"
        width="100%"
        height="1300"
      ></iframe>
    </div>
  );
}
